/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Bold_Finch_LeapInputs */

const en_cool_bold_finch_leap = /** @type {(inputs: Cool_Bold_Finch_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const de_cool_bold_finch_leap = /** @type {(inputs: Cool_Bold_Finch_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Cool_Bold_Finch_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_bold_finch_leap = /** @type {((inputs?: Cool_Bold_Finch_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Bold_Finch_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_bold_finch_leap(inputs)
	return de_cool_bold_finch_leap(inputs)
});